import { render, staticRenderFns } from "./GuardianTopPage.vue?vue&type=template&id=58055a05&scoped=true"
import script from "./GuardianTopPage.vue?vue&type=script&lang=js"
export * from "./GuardianTopPage.vue?vue&type=script&lang=js"
import style0 from "./GuardianTopPage.vue?vue&type=style&index=0&id=58055a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58055a05",
  null
  
)

export default component.exports